export const GIT_HASH = '1fc29e0d5';
